import type { LayoutConfig } from "golden-layout";

export const SharedLayoutConfig: (_: boolean) => LayoutConfig = (isMobile: boolean) => ({
  root: {
    type: isMobile ? "column" : "row" as const,
    content: [
      {
        type: "component" as const,
        componentType: "map",
        title: "Map",
        size: isMobile ? "100%" : "70%",
        reorderEnabled: false,
      },
      {
        type: "component" as const,
        componentType: "mapNavigationPanel",
        size: isMobile ? "100%" : "30%",
        title: "Map",
        minSize: "170px",
        reorderEnabled: false,
        header: { show: false },
      },
    ],
  },
  dimensions: {
    borderWidth: 10,
    borderGrabWidth: 18,
    headerHeight: 26,
  },
  settings: {
    constrainDragToContainer: true,
    reorderEnabled: true,
    showPopoutIcon: false,
    showMaximiseIcon: true,
    showCloseIcon: true,
  },
  header: {
    show: "top",
    popout: false,
    maximise: "Maximize pane",
    close: "Close pane",
  },
});
